/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardBundleFilterBindingDto } from './dashboard-bundle-filter-binding-dto';
import { TrendTileSettingsDto } from './trend-tile-settings-dto';
import { TileLocalizedTitleDto } from './tile-localized-title-dto';


export interface DashboardBundleItemDto { 
    /**
     * Key of the bundled KPI this tile renders. Must appear in the bundle\'s kpis list.
     */
    kpiKey: string;
    /**
     * Freeform tile layout state owned by the UI.
     */
    layout?: { [key: string]: any; };
    /**
     * Sort order for this tile within the dashboard. Defaults to its position in the list.
     */
    order?: number;
    /**
     * Display title for this tile, in English; falls back to the localized KPI title.
     */
    titleOverride?: string | null;
    /**
     * The tile\'s title override in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"titleOverride\": \"Neue Mitglieder\"}, \"cs\": {\"titleOverride\": \"Noví členové\"}}. English goes in the plain titleOverride; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain titleOverride. With neither, the tile shows the KPI title in the viewer\'s language. Omitted or null: no translations.
     */
    i18n?: { [key: string]: TileLocalizedTitleDto; } | null;
    /**
     * Visibility status for this tile. Defaults to visible.
     */
    status?: DashboardBundleItemDto.StatusEnum;
    /**
     * Mappings from dashboard filters to KPI parameters for this tile.
     */
    filterBindings?: Array<DashboardBundleFilterBindingDto>;
    /**
     * Trend tiles only: what the tile compares with. Omitted or null means [previous_period].
     */
    trend?: TrendTileSettingsDto | null;
}
export namespace DashboardBundleItemDto {
    export const StatusEnum = {
        Visible: 'visible',
        Hidden: 'hidden'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


